import { createStore } from "vuex";
import router from "../router";
import { events } from "../events";
import { Storage } from "@capacitor/storage";
import {
  obtainJWT,
  refreshJWT,
  accountUrl,
  regUrl,
  chats,
  appUrl,
  acceptFriendRequest,
  declineFriendRequest,
  friendRequest,
  friendRequestCancel,
  removeFriend,
  friendRequests,
  createMessagesUrl,
  createMessagesUr,
  newReed,
  urlStories,
  unreadNotifications,
  markAllAsRead,
  markSomeAsRead,
  friendSuggestions,
  searchHyreads,
  chatDelete,
  chatReact,
  appUrlVideo,
  feeds,
  userCurrentLocation,
  registerNotifTokenURL,
  newVisto,
  singlePostView,
  newFeed,
  newComment,
  newReaction,
  newVote,
  deleteVote,
} from "../constants/endpoints";
const store = createStore({
  state() {
    return {
      tags: [],
      userCurrentLocation: null,
      replyToComment: false,
      allPostLoader: true,
      showLoader: false,
      feedPage: 1,
      feeds: [],
      page: 1,
      friendSent: [],
      friendSuggestions: [],
      users: [],
      unreadNotifications: [],
      allStoryLoader: true,
      stories: [],
      story_id: null,
      conversationList: null,
      userDetails: null,
      avatar: "profiles/placeholder.png",
      error: null,
      hide: false,
      loading: false,
      jwt: null,
      authuser: null,
      endpoints: {
        obtainJWT: obtainJWT,
        refreshJWT: refreshJWT,
        regUrl: regUrl,
        accountUrl: accountUrl,
        chats: chats,
        appUrl: appUrl,
        acceptFriendRequest: acceptFriendRequest,
        declineFriendRequest: declineFriendRequest,
        friendRequest: friendRequest,
        friendRequestCancel: friendRequestCancel,
        removeFriend: removeFriend,
        friendRequests: friendRequests,
        createMessagesUrl: createMessagesUrl,
        createMessagesUr: createMessagesUr,
        newReed: newReed,
        newFeed: newFeed,
        newReaction: newReaction,
        newVote: newVote,
        newComment: newComment,
        urlStories: urlStories,
        unreadNotifications: unreadNotifications,
        markAllAsRead: markAllAsRead,
        markSomeAsRead: markSomeAsRead,
        friendSuggestions: friendSuggestions,
        searchHyreads: searchHyreads,
        chatDelete: chatDelete,
        chatReact: chatReact,
        appUrlVideo: appUrlVideo,
        feeds: feeds,
        userCurrentLocation: userCurrentLocation,
        registerNotifTokenURL: registerNotifTokenURL,
        newVisto: newVisto,
        singlePostView: singlePostView,
        deleteVote: deleteVote,
      },
    };
  },
  getters: {
    getNNuevos(state) {
      return (idPersona) => {
        const indice = state.stories.findIndex(
          (element) => element.id == idPersona
        );
        const nuevos = state.stories[indice].estados.filter(
          (element) => !element.visto
        );
        return nuevos.length;
      };
    },
    getNEstados(state) {
      return (idPersona) => {
        const indice = state.stories.findIndex(
          (element) => element.id == idPersona
        );
        return state.stories[indice].estados.length;
      };
    },
    getHora(state) {
      return (idPersona) => {
        const indice = state.stories.findIndex(
          (element) => element.id == idPersona
        );
        return state.stories[indice].estados[
          state.stories[indice].estados.length - 1
        ].created_at;
      };
    },

    getEstados(state) {
      return (idPersona) => {
        const index = state.stories.findIndex(
          (element) => element.id == idPersona
        );
        return state.stories[index].estados;
      };
    },
    getIndex(state) {
      return (idPersona) => {
        const index = state.stories.findIndex(
          (element) => element.id == idPersona
        );
        return index;
      };
    },
    getAuthUser(state) {
      return state.authuser;
    },
    getStories(state) {
      return state.stories;
    },
    getSilenciados(state) {
      const resultado = state.stories.filter((element) => element.silenciado);

      return resultado;
    },
    getRecientes(state) {
      const resultado = state.stories.filter((element) => {
        if (element.silenciado) return false; //si esta silenciado se salta el elemento

        const cantidadStories = element.estados.length;

        const nVistos = element.estados.reduce((total, actual) => {
          if (actual.visto) return total + 1;
        }, 0);

        if (cantidadStories != nVistos) return true;
      });

      return resultado;
    },
    getVistos(state) {
      const resultado = state.stories.filter((element) => {
        if (element.silenciado) return false; //si esta silenciado se salta el elemento

        const cantidadStories = element.estados.length;

        const nVistos = element.estados.reduce((total, actual) => {
          if (actual.visto) return total + 1; //si esta visto suma 1
        }, 0);

        if (cantidadStories == nVistos) return true;
      });

      return resultado;
    },
  },
  actions: {
    userCurrentLocation(context) {
      axios
        .get(`${context.state.endpoints.userCurrentLocation}`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          context.state.userCurrentLocation = response.data;
        });
    },
    friendSuggestions(context) {
      axios
        .get(`${context.state.endpoints.friendSuggestions}`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          context.state.friendSuggestions = response.data.friends;
          context.state.friendSent = response.data.sent;
        });
    },
    unreadNotifications(context) {
      axios
        .get(`${context.state.endpoints.unreadNotifications}`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          context.state.unreadNotifications = response.data;
        });
    },
    async stories(context) {
      await axios
        .get(`${context.state.endpoints.urlStories}`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          context.state.stories = response.data.filter(
            (data) => data.has_estado == true
          );
          context.state.allStoryLoader = false;
        });
    },
    feeds(context) {
      axios
        .get(`${context.state.endpoints.feeds}`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          // context.state.conversationList = response.data.data;
          context.state.feeds = response.data.data;
          context.state.feedPage = 2;
          context.state.allPostLoader = false;
        });
    },
    chatList(context) {
      axios
        .get(`${context.state.endpoints.chats}/`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          // context.state.conversationList = response.data.data;
          context.state.users = response.data.data;
          context.state.tags = response.data.data;
          context.state.page = 2;
        });
    },
    accountDetails(context, { id }) {
      axios
        .get(`${context.state.endpoints.accountUrl}/${id}/`, {
          headers: { Authorization: `Bearer ${context.state.jwt}` },
        })
        .then((response) => {
          context.state.userDetails = response.data;
          context.state.story_id = response.data.storyid;
        });
    },
    registerAccount(context, user) {
      axios.post(context.state.endpoints.regUrl, user).then((response) => {
        this.dispatch("obtainToken", user);
        if (context.state.jwt) {
          this.dispatch("stories");
          this.dispatch("unreadNotifications");
        }
      });
    },
    obtainToken(context, user) {
      axios
        .post(context.state.endpoints.obtainJWT, user)
        .then((response) => {
          this.commit("updateToken", response.data.token);
          this.commit("updateUser", JSON.stringify(response.data.user));
          axios
            .get(`${context.state.endpoints.friendRequest}${21}`, {
              headers: { Authorization: `Bearer ${response.data.token}` },
            })
            .then(() => {
              console.log();
            });
          axios
            .post(
              `${context.state.endpoints.createMessagesUr}${response.data.user.id}/`,
              {
                message: `Hello (${response.data.user.username})
              Welcome to Creeb, a platform for the education of the mind, a haven for the enlightenment of the soul and a sanctuary for the empowerment of society.
              Be part of our community of seekers of knowledge and intellectual nourishment. Engage with us on how to build a better world. Share your wisdom on how to weave together a Just society, how to transcend our limitations and expand the boundaries of human knowledge. Your idea is the foundation stone to fortify our shared fortress, your passion the fire to energize our united body, your integrity the torch to light our common path.
              Let’s tailor our destiny. Lets define our era.
  
              Regards,
              Hyreads.
  
              (For more information about Hyreads, our programs, features and much more, visit our blog)`,
                sender_id: 21,
              },
              { headers: { Authorization: `Bearer ${response.data.token}` } }
            )
            .then(() => {
              console.log();
            });
          setTimeout(() => {
            this.dispatch("stories");
            this.dispatch("unreadNotifications");
            router.go("/home");
          }, 3000);
        })
        .catch((error) => {
          window.HyreadsEvents.emit(
            events.NEW_ERROR,
            error.response.data.non_field_errors[0]
          );
          console.log("error", error.response.data.non_field_errors[0]);
          // console.log("new error", error)
        });
    },
    loginToken(context, user) {
      axios
        .post(context.state.endpoints.obtainJWT, user)
        .then((response) => {
          this.commit("updateToken", response.data.token);
          this.commit("updateUser", JSON.stringify(response.data.user));

          router.go("/home");
        })
        .catch((error) => {
          window.HyreadsEvents.emit(
            events.NEW_ERROR,
            error.response.data.non_field_errors[0]
          );
          console.log("error", error.response.data.non_field_errors[0]);
          // console.log("new error", error)
        });
    },
    refreshToken(context) {
      const payload = {
        token: context.state.jwt,
      };
      axios
        .post(context.state.endpoints.refreshJWT, payload)
        .then((response) => {
          this.commit("updateToken", response.data.token);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    inspectToken() {
      const token = this.state.jwt;
      if (token) {
        const decoded = jwt_decode(token);
        const exp = decoded.exp;
        const orig_iat = decode.orig_iat;
        if (
          exp - Date.now() / 1000 < 1800 &&
          Date.now() / 1000 - orig_iat < 628200
        ) {
          this.dispatch("refreshToken");
        } else if (exp - Date.now() / 1000 < 1800) {
          // DO NOTHING, DO NOT REFRESH
        } else {
          // PROMPT USER TO RE-LOGIN, THIS ELSE CLAUSE COVERS THE CONDITION WHERE A TOKEN IS EXPIRED AS WELL
        }
      }
    },
  },
  mutations: {
    allStories(state, data) {
      return (state.stories = data);
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
    updateUser(state, newUser) {
      // localStorage.setItem('user', newUser);
      Storage.set({
        key: "user",
        value: newUser,
      });
      state.authuser = newUser;
    },
    updateToken(state, newToken) {
      // localStorage.setItem('token', newToken);
      Storage.set({
        key: "token",
        value: newToken,
      });
      state.jwt = newToken;
    },
    removeToken(state) {
      // localStorage.removeItem('token');
      Storage.remove({
        key: "token",
      });
      Storage.remove({
        key: "user",
      });
      state.jwt = null;
      state.authuser = null;
    },
  },
});
export default store;
const jwt = Storage.get({
  key: "token",
});
jwt.then((response) => {
  store.state.jwt = response.value;
});

const user = Storage.get({
  key: "user",
});
user.then((response) => {
  store.state.authuser = JSON.parse(response.value);
});
